import { render, staticRenderFns } from "./childSizeChart.vue?vue&type=template&id=be616156&"
import script from "./childSizeChart.vue?vue&type=script&lang=js&"
export * from "./childSizeChart.vue?vue&type=script&lang=js&"
import style0 from "./childSizeChart.vue?vue&type=style&index=0&id=be616156&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports